export default "__VITE_ASSET__8440e988__"